import memoize from "lodash/memoize";

import type { SimilarwebFieldsConfig } from "app/pages/sales-intelligence/common-components/export-table/types";

import { getAccountsSourceFieldsConfig } from "./accountsFields";
import { getContactsSourceFieldsConfig } from "./contactsFields";
import { getRequesterFieldsConfig } from "./requesterFields";
import { getSubsidiaryFieldsConfig } from "./subsidiaryFields";

export const getLeadsFields = memoize(
    (): Readonly<SimilarwebFieldsConfig> =>
        Object.seal({
            ...getAccountsSourceFieldsConfig(),
            ...getContactsSourceFieldsConfig(),
            ...getRequesterFieldsConfig(),
            ...getSubsidiaryFieldsConfig(),
        }),
);
